

import '../requestDetail.scss';
import { ISessionService } from '../../../../core/sessions/sessionService';
import {IRequestDetailService} from '../services/requestDetailService';
import {RequestAllDetails} from '../models/requestAllDetails';
import { RequestDetail } from '../models/requestDetail';
import { RequestMaterial } from '../models/requestMaterial';
import { addRequestState } from '../../addRequest/states/addRequestState';
import { INotificationService } from '../../../../core/notificationService';

import { RequestDetailEdit } from "../../requestDetailEdit/models/requestDetailEdit";
import { IRequestDetailEditService } from "../../requestDetailEdit/services/requestDetailEditService";

export class RequestDetailController implements ng.IController {
    static $inject = ['requestDetailService', '$state', '$stateParams', '$scope', '$mdMedia',
        'SessionService', 'NotificationService', '$mdDialog', 'requestDetailEditService'];
    private _trackingId: number;
    private _isLoading: boolean;
    private _details: RequestAllDetails;

    constructor(private requestDetailService: IRequestDetailService,
        protected _$state: angular.ui.IStateService,
        private _$stateParams: angular.ui.IStateParamsService,
        private _$scope: angular.IScope,
        private _$mdMedia: angular.material.IMedia,
        private _sessionService: ISessionService,
        private _notificationService: INotificationService,
        private _$mdDialog: ng.material.IDialogService,
        private _requestDetailEditService: IRequestDetailEditService) {
    }

    $onInit() {
        this._trackingId = this._$stateParams['trackingId'];
        this._isLoading = true;
        this.requestDetailService.getDetail(this._trackingId, true)
            .then(v => this.handleGetDetail(v))
            .catch((err: unknown) => { });
    }
    
    private handleGetDetail(details: RequestAllDetails): void {
        if (details !== undefined && details !== null &&
            details.errorMessage !== null && details.errorMessage !== undefined && details.errorMessage.length > 0) {
            this._notificationService.showToastWithMentionedDelay(details.errorMessage, 5000);
        } else {
            this._details = details;
        }
        this._isLoading = false;
         this._$scope.$apply();
    }
    
    copyRequest(trackingId: number): void {
       
        this._isLoading = true;
        this._requestDetailEditService.getDetail(this.trackingId, false)
            .then(v => this.handleCopyGetDetail(v))
            .catch((err: unknown) => { });
    }
    private handleCopyGetDetail(details: RequestDetailEdit): void {
       
        this._isLoading = false;
        if (details.errorMessage !== null && details.errorMessage !== undefined && details.errorMessage.length > 0) {
            this._notificationService.showToastWithMentionedDelay(details.errorMessage, 5000);
        } else {
            this._$state.go(addRequestState.name, { copyRequestDetailEdit: details });
        }
    }
    get requestDetail(): RequestDetail {
        return this._details ? this._details.details : undefined;
    }

    get requestMaterial(): RequestMaterial {
        return this._details ? this._details.materials : undefined;  
    }

    get requestAllDetails(): RequestAllDetails  {
        return this._details ? this._details : undefined;
    }

    get trackingId() :number {
        return this._trackingId;
    }


    get isLoading(): boolean {
        return this._isLoading;
    }

    generatePreShipmentRequestLetter(letterTrackingId: number, ev): void {

        const confirm = this._$mdDialog.confirm()
            .parent(angular.element(document.body))
            .textContent('Are you sure you would like to Print this Request?')
            .ok('Ok')
            .cancel('Cancel')
            .targetEvent(ev);
        this._$mdDialog.show(confirm)
            .then(() => {
                this._isLoading = true;
                this.generateprintpdf(letterTrackingId);
               
              
            })
            .catch((err: unknown) => { });
    }

    private printDocument() : void {
    var divToPrint = document.getElementById('request-letter');
    var newWin = window.open('', 'Print-Window');

    newWin.document.open();

    newWin.document.write('<html><head><style>td{border:1px solid black;} </style></head><body onload="window.print()">' + divToPrint.innerHTML + '</body></html>');

    newWin.document.close();
    
    setTimeout(() => { newWin.close(); }, 10);

    this._isLoading = false;
}

    private generateprintpdf(letterTrackingId : number): void {
        this.requestDetailService.getDetail(letterTrackingId, false)
            .then(r => {

                if (r !== undefined &&
                    r !== null &&
                    r.errorMessage !== null &&
                    r.errorMessage !== undefined &&
                    r.errorMessage.length > 0) {
                    this._isLoading = false;
                    this._notificationService.showToastWithMentionedDelay(r.errorMessage, 5000);
                } else {
                   
                    this.requestDetailService.generateRequestLetterByTrackingId(this._trackingId)
                        .then(r => {

                                if (r.byteLength === 0) {
                                    this._notificationService
                                        .showToastWithMentionedDelay("PDF generation in progress, please wait. If you see this message after several minutes, please contact support.",
                                            5000);
                                } else {
                                    var byteArray = new Uint8Array(r);
                                    var file = new Blob([byteArray], { type: 'application/pdf' });
                                    const fileUrl = URL.createObjectURL(file);
                                    window.open(fileUrl);
                                }
                                this._isLoading = false;
                            this._$scope.$apply();
                        })
                        .catch((r) => {
                            this.handleSaveError(r);
                            this._isLoading = false;
                            this._$scope.$apply();
                        });
                } 
            });
    }

    private handleSaveError(saveResult): void {
        this._isLoading = false;
        this._notificationService.showToast(this.extractError(saveResult));
    }
    private extractError(result) {
        return (result && result.errors && result.errors.length > 0) ? result.errors[0] : 'Unexpected error occurred';
    }

}
angular.module('deliveryCreate.app').controller('requestDetailController', RequestDetailController);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/controllers/requestDetailController.ts
 **/